import Link from "next/link";
import React from "react";
import Button from "../buttons/Button";
import Header from "../header/Header";

const ActivatePortfolioCard = () => {
  return (
    <div className="p-4 bg-white rounded shadow-xl dark:bg-theme-dark-light dark:shadow-none">
      <Header as="h4" className="mb-2 text-primary">
        Activar Portafolio PRO
      </Header>

      <p className="text-sm">
        Recuerda que puedes construir un portafolio <strong>PREMIUM</strong> con
        los proyectos que has realizado en un clic, solo por ser miembro premium
      </p>

      <Link href="/">
        <Button type="primary" size="sm" className="mt-4" block>
          Crear portafolio
        </Button>
      </Link>
    </div>
  );
};

export default ActivatePortfolioCard;
